module.exports = "https://static.wanderu.com/ui-react/_next/static/media/nl.f5d20958.svg";